(() => {
  const rules = window.hhPantryPairingRules || {sources: {}, variants: {}, targets: {}};
  const api = window.hhCampaignLimits;
  if (!api) return;
  let config = {};
  try { config = JSON.parse(document.getElementById('HHCampaignLimits')?.textContent || '{}'); } catch {}
  const text = config.pairingMessages || {};
  const node = (tag, className, content) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (content) element.textContent = content;
    return element;
  };
  const service = {
    source(form) {
      const variant = String(form.elements?.namedItem('id')?.value || '');
      if (rules.variants[variant]) return rules.variants[variant];
      const current = config.currentProduct;
      const group = rules.types?.[current?.type];
      if (!current?.id || !group || !(current.variants || []).some(id => String(id) === variant)) return;
      const id = String(current.id);
      rules.sources[id] = {group, targets: (rules.groups[group] || []).filter(key => rules.targets[key].id !== id)};
      for (const value of current.variants) rules.variants[String(value)] = id;
      return id;
    },
    occupiedProducts(cart) {
      const result = new Set((cart.items || []).map(item => String(item.product_id)));
      for (const variant of api.occupiedVariants(cart)) if (rules.variants[variant]) result.add(rules.variants[variant]);
      return result;
    },
    definitions(panel, id) {
      const template = document.getElementById('HHCampaignPairings-' + id);
      if (template) return [...template.content.querySelectorAll('[data-hh-pair-variant]')].map(card => {
        const url = new URL(card.href, location.origin);
        return {id: card.dataset.hhPairProduct, variant: card.dataset.hhPairVariant, handle: url.pathname.split('/products/')[1]?.split('/')[0]};
      }).filter(definition => definition.handle);
      return (rules.sources[id]?.targets || []).map(key => rules.targets[key]).filter(Boolean);
    },
    async product(definition, root) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 6500);
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(definition.handle) + '.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}, signal: controller.signal});
        if (!response.ok) return null;
        const product = await response.json();
        if (String(product.id) !== String(definition.id) || product.requires_selling_plan) return null;
        const variant = (product.variants || []).find(item => String(item.id) === String(definition.variant));
        if (!variant?.available || !Number.isFinite(variant.price)) return null;
        return {product, variant};
      } catch { return null; }
      finally { clearTimeout(timer); }
    },
    card({product, variant}, coordinator) {
      const card = node('article', 'hh-continue__product');
      card.dataset.hhPairProduct = String(product.id); card.dataset.hhPairVariant = String(variant.id);
      const url = coordinator.root + 'products/' + encodeURIComponent(product.handle) + '?variant=' + variant.id;
      const pictureLink = node('a', 'hh-continue__picture'); pictureLink.href = url; pictureLink.setAttribute('aria-label', product.title);
      const imageSource = variant.featured_image?.src || product.featured_image;
      if (imageSource) {
        const image = node('img');
        const imageUrl = new URL(imageSource, location.origin); imageUrl.searchParams.set('width', '200');
        image.src = imageUrl.href; image.alt = product.title; image.width = 88; image.height = 112; image.loading = 'lazy'; image.decoding = 'async';
        pictureLink.append(image);
      }
      const body = node('div', 'hh-continue__product-copy');
      const brand = node('small', 'hh-continue__brand', product.vendor); body.append(brand);
      let title = product.title;
      if (product.vendor && title.toLowerCase().startsWith(product.vendor.toLowerCase())) title = title.slice(product.vendor.length).replace(/^\s*[–—-]?\s*/, '');
      const link = node('a', 'hh-continue__title', title); link.href = url; body.append(link);
      if (variant.title && variant.title !== 'Default Title') body.append(node('small', 'hh-continue__size', variant.title));
      const actions = node('div', 'hh-continue__product-actions');
      const currency = window.Shopify?.currency?.active || config.currency || 'AUD';
      actions.append(node('strong', '', new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style: 'currency', currency}).format(variant.price / 100)));
      const form = node('form', 'hh-continue__add-form'); form.action = coordinator.root + 'cart/add'; form.method = 'post'; form.dataset.hhPairAddForm = ''; form.dataset.hhPairName = product.title;
      for (const [name, value] of [['id', variant.id], ['quantity', 1]]) { const input = node('input'); input.type = 'hidden'; input.name = name; input.value = String(value); form.append(input); }
      const button = node('button', 'hh-continue__add'); button.type = 'submit'; button.setAttribute('aria-label', (text.add_product || '').replace('__PRODUCT__', product.title));
      button.append(node('span', '', text.add || 'Add')); form.append(button); actions.append(form); body.append(actions); card.append(pictureLink, body);
      return card;
    },
    async populate(panel, id, cart, coordinator) {
      if (panel.dataset.hhPairingsLoading === 'true' || panel.dataset.hhPairingsLoaded === 'true') return;
      const definitions = this.definitions(panel, id);
      if (!definitions.length) return;
      panel.dataset.hhPairingsLoading = 'true';
      const container = panel.querySelector('.hh-continue__products');
      const group = panel.querySelector('[data-hh-continue-pairings]');
      group.hidden = true;
      try {
        const loaded = await Promise.all(definitions.slice(0, 4).map(definition => this.product(definition, coordinator.root)));
        if (!panel.isConnected) return;
        const current = coordinator.cart || cart;
        const occupied = api.occupiedVariants(current);
        const occupiedProducts = this.occupiedProducts(current);
        const selected = loaded.filter(Boolean).filter(({product, variant}) => !occupied.has(String(variant.id)) && !occupiedProducts.has(String(product.id))).slice(0, 2);
        const cards = selected.map(item => this.card(item, coordinator));
        container.replaceChildren(...cards);
        const heading = panel.querySelector('h3'); heading.textContent = text.heading || 'Better together';
        let eyebrow = panel.querySelector('.hh-continue__eyebrow');
        if (!eyebrow) { eyebrow = node('p', 'hh-continue__eyebrow', text.eyebrow); heading.before(eyebrow); }
        panel.dataset.hhPairingsLoaded = 'true';
        delete panel.dataset.hhPairingsLoading;
        api.paintContinuation(current);
      } catch {
        container.replaceChildren(); group.hidden = true;
      } finally { delete panel.dataset.hhPairingsLoading; }
    }
  };
  window.hhPantryPairings = service;
})();
